import React, { useState, useEffect, useRef } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { useHistory } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

// ─────────────────────────────────────────────────────────────────────────────
// Template flow JSONs
// ─────────────────────────────────────────────────────────────────────────────

const ES = { stroke: "#94a3b8", strokeWidth: "2.5px" };

const FLOW_TEMPLATES = {
  blank: null,

  welcome_menu: {
    nodes: [
      { id: "1",     type: "start",   data: { label: "Inicio do fluxo" },                                                                                        position: { x: 50,  y: 220 }, style: {} },
      { id: "wm_m1", type: "message", data: { label: "Olá! Bem-vindo! Como posso te ajudar hoje? 😊" },                                                          position: { x: 320, y: 220 }, style: {} },
      { id: "wm_mn", type: "menu",    data: { message: "Escolha uma opção:", arrayOption: [{number:1,value:"Atendimento"},{number:2,value:"Preços"},{number:3,value:"Horários"}], typeMenu: "number" }, position: { x: 610, y: 220 }, style: {} },
      { id: "wm_r1", type: "message", data: { label: "Um de nossos atendentes entrará em contato em breve! 👋" },                                                 position: { x: 920, y: 60  }, style: {} },
      { id: "wm_r2", type: "message", data: { label: "Nossos planos começam a partir de R$99/mês. Entre em contato para mais detalhes!" },                       position: { x: 920, y: 240 }, style: {} },
      { id: "wm_r3", type: "message", data: { label: "Funcionamos de segunda a sexta, das 8h às 18h. ⏰" },                                                      position: { x: 920, y: 420 }, style: {} },
    ],
    connections: [
      { id: "reactflow__edge-1a-wm_m1",      source: "1",     sourceHandle: "a",  target: "wm_m1", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-wm_m1a-wm_mn",  source: "wm_m1", sourceHandle: "a",  target: "wm_mn", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-wm_mna1-wm_r1", source: "wm_mn", sourceHandle: "a1", target: "wm_r1", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-wm_mna2-wm_r2", source: "wm_mn", sourceHandle: "a2", target: "wm_r2", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-wm_mna3-wm_r3", source: "wm_mn", sourceHandle: "a3", target: "wm_r3", targetHandle: null, style: ES, animated: false },
    ],
  },

  ai_assistant: {
    nodes: [
      { id: "1",     type: "start",   data: { label: "Inicio do fluxo" },                                                                                        position: { x: 50,  y: 220 }, style: {} },
      { id: "ai_m1", type: "message", data: { label: "Olá! Sou o assistente virtual. Como posso te ajudar hoje? 🤖" },                                           position: { x: 320, y: 220 }, style: {} },
      { id: "ai_oa", type: "openai",  data: { typebotIntegration: { name: "Assistente Virtual", prompt: "Você é um assistente virtual útil e simpático. Responda as dúvidas do cliente de forma clara e objetiva. Seja sempre educado e prestativo.", flowMode: "permanent", provider: "openai", model: "gpt-3.5-turbo" } }, position: { x: 630, y: 220 }, style: {} },
    ],
    connections: [
      { id: "reactflow__edge-1a-ai_m1",     source: "1",     sourceHandle: "a", target: "ai_m1", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-ai_m1a-ai_oa", source: "ai_m1", sourceHandle: "a", target: "ai_oa", targetHandle: null, style: ES, animated: false },
    ],
  },

  lead_qualification: {
    nodes: [
      { id: "1",     type: "start",   data: { label: "Inicio do fluxo" },                                                                                        position: { x: 50,   y: 220 }, style: {} },
      { id: "lq_m1", type: "message", data: { label: "Olá! Para te ajudar melhor, preciso de algumas informações rápidas. 📋" },                                 position: { x: 300,  y: 220 }, style: {} },
      { id: "lq_i1", type: "input",   data: { question: "Qual é o seu nome?",            variableName: "nome" },                                                 position: { x: 570,  y: 220 }, style: {} },
      { id: "lq_i2", type: "input",   data: { question: "Qual é o seu e-mail?",          variableName: "email" },                                                position: { x: 840,  y: 220 }, style: {} },
      { id: "lq_i3", type: "input",   data: { question: "O que você está procurando?",   variableName: "interesse" },                                            position: { x: 1110, y: 220 }, style: {} },
      { id: "lq_m2", type: "message", data: { label: "Perfeito! Recebemos suas informações e um atendente entrará em contato em breve. 🎉" },                    position: { x: 1380, y: 220 }, style: {} },
    ],
    connections: [
      { id: "reactflow__edge-1a-lq_m1",     source: "1",     sourceHandle: "a", target: "lq_m1", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-lq_m1a-lq_i1", source: "lq_m1", sourceHandle: "a", target: "lq_i1", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-lq_i1a-lq_i2", source: "lq_i1", sourceHandle: "a", target: "lq_i2", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-lq_i2a-lq_i3", source: "lq_i2", sourceHandle: "a", target: "lq_i3", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-lq_i3a-lq_m2", source: "lq_i3", sourceHandle: "a", target: "lq_m2", targetHandle: null, style: ES, animated: false },
    ],
  },

  tech_support: {
    nodes: [
      { id: "1",     type: "start",   data: { label: "Inicio do fluxo" },                                                                                        position: { x: 50,  y: 220 }, style: {} },
      { id: "ts_m1", type: "message", data: { label: "Olá! Bem-vindo à central de suporte técnico. 🛠️ Como posso ajudar?" },                                    position: { x: 320, y: 220 }, style: {} },
      { id: "ts_mn", type: "menu",    data: { message: "Selecione o tipo de suporte:", arrayOption: [{number:1,value:"Problema técnico"},{number:2,value:"Dúvida"},{number:3,value:"Reclamação"}], typeMenu: "number" }, position: { x: 610, y: 220 }, style: {} },
      { id: "ts_r1", type: "message", data: { label: "Vou registrar seu problema técnico. Um especialista te atenderá em breve! 🔧" },                           position: { x: 920, y: 60  }, style: {} },
      { id: "ts_r2", type: "message", data: { label: "Pode perguntar! Nossa equipe está pronta para esclarecer todas as suas dúvidas. 💡" },                     position: { x: 920, y: 240 }, style: {} },
      { id: "ts_r3", type: "message", data: { label: "Lamentamos o inconveniente. Sua reclamação será encaminhada para a equipe responsável. 😔" },              position: { x: 920, y: 420 }, style: {} },
    ],
    connections: [
      { id: "reactflow__edge-1a-ts_m1",      source: "1",     sourceHandle: "a",  target: "ts_m1", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-ts_m1a-ts_mn",  source: "ts_m1", sourceHandle: "a",  target: "ts_mn", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-ts_mna1-ts_r1", source: "ts_mn", sourceHandle: "a1", target: "ts_r1", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-ts_mna2-ts_r2", source: "ts_mn", sourceHandle: "a2", target: "ts_r2", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-ts_mna3-ts_r3", source: "ts_mn", sourceHandle: "a3", target: "ts_r3", targetHandle: null, style: ES, animated: false },
    ],
  },

  agent_inteligente: {
    nodes: [
      { id: "1",      type: "start",   data: { label: "Inicio do fluxo" }, position: { x: 50,  y: 220 }, style: {} },
      { id: "ag_m1",  type: "message", data: { label: "Olá! 🤖 Em breve nosso agente inteligente irá te atender." }, position: { x: 300, y: 220 }, style: {} },
      {
        id: "ag_ag",
        type: "agent",
        data: {
          agentSettings: {
            name:         "Assistente IA",
            systemPrompt: "Você é um assistente de atendimento simpático e profissional.\n\nSua missão:\n- Responder dúvidas com clareza\n- Coletar informações relevantes do cliente\n- Transferir para a fila correta quando necessário\n- Encerrar o atendimento após resolver o problema\n\nSempre cumprimente pelo nome quando souber. Seja objetivo e gentil.",
            model:        "gpt-4o-mini",
            apiKey:       "",
            temperature:  0.7,
            maxTokens:    1000,
            maxMessages:  10,
            maxTurns:     5,
            tools: {
              transferir_para_fila:  true,
              adicionar_tag:         true,
              remover_tag:           false,
              salvar_dado_cliente:   true,
              encerrar_atendimento:  true,
            },
          },
        },
        position: { x: 620, y: 220 },
        style: {},
      },
    ],
    connections: [
      { id: "reactflow__edge-1a-ag_m1",    source: "1",     sourceHandle: "a", target: "ag_m1", targetHandle: null, style: ES, animated: false },
      { id: "reactflow__edge-ag_m1a-ag_ag", source: "ag_m1", sourceHandle: "a", target: "ag_ag", targetHandle: null, style: ES, animated: false },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mini ilustrações de conversa para cada card
// ─────────────────────────────────────────────────────────────────────────────

const IllustrationBlank = () => (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 8 }}>
    <div style={{ width: 44, height: 44, border: "2px dashed #94a3b8", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(255,255,255,0.6)" }}>
      <span style={{ fontSize: 22, color: "#64748b", lineHeight: 1 }}>+</span>
    </div>
    <div style={{ display: "flex", gap: 4 }}>
      {[38, 52, 28].map((w, i) => (
        <div key={i} style={{ width: w, height: 7, background: "#cbd5e1", borderRadius: 4 }} />
      ))}
    </div>
    <div style={{ display: "flex", gap: 4 }}>
      {[24, 44].map((w, i) => (
        <div key={i} style={{ width: w, height: 7, background: "#e2e8f0", borderRadius: 4 }} />
      ))}
    </div>
  </div>
);

const IllustrationWelcome = () => (
  <div style={{ width: "100%", padding: "10px 12px 6px", display: "flex", flexDirection: "column", gap: 5, boxSizing: "border-box" }}>
    {/* Bot bubble */}
    <div style={{ background: "#dcfce7", borderRadius: "4px 12px 12px 12px", padding: "5px 9px", fontSize: 10, color: "#166534", maxWidth: "85%", lineHeight: 1.4, boxShadow: "0 1px 2px rgba(0,0,0,0.08)" }}>
      Olá! 👋 Como posso ajudar?
    </div>
    {/* Option buttons */}
    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
      {["Atendimento", "Preços", "Horários"].map((label, i) => (
        <div key={i} style={{ background: "white", border: "1px solid #bbf7d0", borderRadius: 6, padding: "3px 7px", fontSize: 9, color: "#166534", fontWeight: 600, boxShadow: "0 1px 2px rgba(0,0,0,0.06)" }}>
          {label}
        </div>
      ))}
    </div>
    {/* User reply */}
    <div style={{ background: "#22c55e", borderRadius: "12px 4px 12px 12px", padding: "4px 9px", fontSize: 9, color: "white", maxWidth: "55%", alignSelf: "flex-end", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>
      Atendimento ✓
    </div>
  </div>
);

const IllustrationAI = () => (
  <div style={{ width: "100%", padding: "10px 12px 6px", display: "flex", flexDirection: "column", gap: 5, boxSizing: "border-box" }}>
    {/* AI bubble with avatar */}
    <div style={{ display: "flex", alignItems: "flex-start", gap: 5 }}>
      <div style={{ width: 22, height: 22, background: "#4f46e5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, flexShrink: 0 }}>🤖</div>
      <div style={{ background: "#e0e7ff", borderRadius: "4px 12px 12px 12px", padding: "5px 9px", fontSize: 10, color: "#3730a3", lineHeight: 1.4, boxShadow: "0 1px 2px rgba(0,0,0,0.08)" }}>
        Como posso ajudar?
      </div>
    </div>
    {/* User bubble */}
    <div style={{ background: "#4f46e5", borderRadius: "12px 4px 12px 12px", padding: "4px 9px", fontSize: 9, color: "white", maxWidth: "65%", alignSelf: "flex-end", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>
      Quero saber os planos
    </div>
    {/* Typing indicator */}
    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
      <div style={{ width: 22, height: 22, background: "#4f46e5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, flexShrink: 0 }}>🤖</div>
      <div style={{ background: "#e0e7ff", borderRadius: "4px 12px 12px 12px", padding: "6px 10px", display: "flex", gap: 3, alignItems: "center" }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{ width: 5, height: 5, background: "#6366f1", borderRadius: "50%", opacity: 0.7 }} />
        ))}
      </div>
    </div>
  </div>
);

const IllustrationLead = () => (
  <div style={{ width: "100%", padding: "10px 12px 6px", display: "flex", flexDirection: "column", gap: 5, boxSizing: "border-box" }}>
    {[
      { label: "Nome", placeholder: "João Silva" },
      { label: "Email", placeholder: "joao@email.com" },
    ].map((field, i) => (
      <div key={i}>
        <div style={{ fontSize: 8, color: "#92400e", fontWeight: 700, marginBottom: 2, textTransform: "uppercase", letterSpacing: "0.05em" }}>{field.label}</div>
        <div style={{ background: "white", border: "1px solid #fcd34d", borderRadius: 5, padding: "4px 7px", fontSize: 9, color: "#78350f", boxShadow: "0 1px 2px rgba(0,0,0,0.06)" }}>
          {field.placeholder}
        </div>
      </div>
    ))}
    <div style={{ background: "linear-gradient(90deg, #f59e0b, #d97706)", borderRadius: 5, padding: "4px 8px", fontSize: 9, color: "white", textAlign: "center", fontWeight: 700, marginTop: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.15)" }}>
      Enviar →
    </div>
  </div>
);

const IllustrationSupport = () => (
  <div style={{ width: "100%", padding: "10px 12px 6px", display: "flex", flexDirection: "column", gap: 5, boxSizing: "border-box" }}>
    {/* Bot bubble */}
    <div style={{ background: "#ffe4e6", borderRadius: "4px 12px 12px 12px", padding: "5px 9px", fontSize: 9, color: "#9f1239", lineHeight: 1.4, maxWidth: "90%", boxShadow: "0 1px 2px rgba(0,0,0,0.08)" }}>
      Selecione o tipo de suporte:
    </div>
    {/* Options */}
    {["1. Problema técnico", "2. Dúvida", "3. Reclamação"].map((opt, i) => (
      <div key={i} style={{ background: "white", border: "1px solid #fecaca", borderRadius: 6, padding: "3px 7px", fontSize: 9, color: "#374151", boxShadow: "0 1px 2px rgba(0,0,0,0.06)" }}>
        {opt}
      </div>
    ))}
  </div>
);

const IllustrationAgent = () => (
  <div style={{ width: "100%", padding: "10px 12px 6px", display: "flex", flexDirection: "column", gap: 5, boxSizing: "border-box" }}>
    {/* Agente responde */}
    <div style={{ display: "flex", alignItems: "flex-start", gap: 5 }}>
      <div style={{ width: 20, height: 20, background: "linear-gradient(135deg, #7c3aed, #a855f7)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, flexShrink: 0 }}>🤖</div>
      <div style={{ background: "#ede9fe", borderRadius: "4px 12px 12px 12px", padding: "5px 9px", fontSize: 9, color: "#4c1d95", lineHeight: 1.4, boxShadow: "0 1px 2px rgba(0,0,0,0.08)" }}>
        Olá! Como posso ajudar?
      </div>
    </div>
    {/* Usuário pergunta */}
    <div style={{ background: "#7c3aed", borderRadius: "12px 4px 12px 12px", padding: "4px 9px", fontSize: 9, color: "white", maxWidth: "60%", alignSelf: "flex-end", boxShadow: "0 1px 2px rgba(0,0,0,0.1)" }}>
      Quero ver meu pedido
    </div>
    {/* Agente executa ação */}
    <div style={{ display: "flex", alignItems: "flex-start", gap: 5 }}>
      <div style={{ width: 20, height: 20, background: "linear-gradient(135deg, #7c3aed, #a855f7)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, flexShrink: 0 }}>🤖</div>
      <div style={{ background: "#ede9fe", borderRadius: "4px 12px 12px 12px", padding: "5px 9px", boxShadow: "0 1px 2px rgba(0,0,0,0.08)" }}>
        <div style={{ display: "flex", gap: 2, alignItems: "center" }}>
          <div style={{ fontSize: 8, color: "#7c3aed", fontWeight: 700 }}>🔧 salvando_dado</div>
        </div>
      </div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// Template metadata
// ─────────────────────────────────────────────────────────────────────────────

const TEMPLATE_OPTIONS = [
  {
    key: "blank",
    IllustrationComp: IllustrationBlank,
    title: "Fluxo em branco",
    description: "Comece do zero com canvas vazio",
    gradient: "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)",
    autoName: "Fluxo sem título",
  },
  {
    key: "welcome_menu",
    IllustrationComp: IllustrationWelcome,
    title: "Boas-vindas + Menu",
    description: "Mensagem de boas-vindas com menu de 3 opções",
    gradient: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
    autoName: "Boas-vindas + Menu",
  },
  {
    key: "ai_assistant",
    IllustrationComp: IllustrationAI,
    title: "Atendimento com IA",
    description: "Assistente OpenAI em modo permanente",
    gradient: "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)",
    autoName: "Atendimento com IA",
  },
  {
    key: "lead_qualification",
    IllustrationComp: IllustrationLead,
    title: "Qualificação de Lead",
    description: "Coleta nome, e-mail e interesse do contato",
    gradient: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
    autoName: "Qualificação de Lead",
  },
  {
    key: "tech_support",
    IllustrationComp: IllustrationSupport,
    title: "Suporte Técnico",
    description: "Triagem de suporte em 3 categorias",
    gradient: "linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)",
    autoName: "Suporte Técnico",
  },
  {
    key: "agent_inteligente",
    IllustrationComp: IllustrationAgent,
    title: "Agente Inteligente",
    description: "Agente IA com Function Calling — toma ações reais na conversa",
    gradient: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)",
    autoName: "Agente Inteligente",
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// Styles
// ─────────────────────────────────────────────────────────────────────────────

const useStyles = makeStyles((theme) => ({
  root: { display: "flex", flexWrap: "wrap" },
  textField: { flex: 1 },
  btnWrapper: { position: "relative" },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  sectionLabel: {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(1.5),
  },
  templateCard: {
    cursor: "pointer",
    borderRadius: 4,
    border: "2px solid transparent",
    transition: "transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease, opacity 0.15s ease",
    height: 200,
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    boxSizing: "border-box",
    userSelect: "none",
    position: "relative",
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    overflow: "hidden",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 20px rgba(0,0,0,0.13)",
    },
  },
  templateCardSelected: {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 1px ${theme.palette.primary.main}, 0 8px 20px rgba(0,0,0,0.1)`,
    transform: "translateY(-2px)",
  },
  templateCardLoading: {
    pointerEvents: "none",
    opacity: 0.85,
  },
  templateCardDimmed: {
    opacity: 0.45,
    pointerEvents: "none",
  },
  illustrationArea: {
    height: 115,
    overflow: "hidden",
    position: "relative",
    flexShrink: 0,
  },
  cardBody: {
    padding: theme.spacing(1, 1.5, 1.5),
    display: "flex",
    flexDirection: "column",
    flex: 1,
    background: "rgba(255,255,255,0.55)",
    backdropFilter: "blur(2px)",
  },
  templateTitle: {
    fontSize: "0.78rem",
    fontWeight: 700,
    color: "#111827",
    lineHeight: 1.3,
    marginBottom: 2,
  },
  templateDesc: {
    fontSize: "0.66rem",
    color: "#6b7280",
    lineHeight: 1.4,
  },
  spinnerWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
}));

// ─────────────────────────────────────────────────────────────────────────────
// Validation
// ─────────────────────────────────────────────────────────────────────────────

const FlowSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Muito curto!")
    .max(50, "Muito longo!")
    .required("Digite um nome!"),
});

// ─────────────────────────────────────────────────────────────────────────────
// Component
// ─────────────────────────────────────────────────────────────────────────────

const FlowBuilderModal = ({
  open,
  onClose,
  flowId,
  nameWebhook = "",
  initialValues,
  onSave,
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);
  const history = useHistory();

  const [selectedTemplate, setSelectedTemplate] = useState("blank");
  const [creating, setCreating] = useState(null);
  const [contact, setContact] = useState({ name: nameWebhook });

  useEffect(() => {
    return () => { isMounted.current = false; };
  }, []);

  useEffect(() => {
    if (open) {
      setSelectedTemplate("blank");
      setCreating(null);
      setContact({ name: nameWebhook || "" });
    }
  }, [open, nameWebhook]);

  const handleClose = () => {
    onClose();
    setContact({ name: "" });
    setSelectedTemplate("blank");
    setCreating(null);
  };

  // Fetch existing flow names and return a unique variant of baseName
  const generateUniqueName = async (baseName) => {
    try {
      const { data } = await api.get("/flowbuilder");
      const flows = Array.isArray(data) ? data : (data.flows || []);
      const existing = new Set(flows.map(f => (f.name || "").trim().toLowerCase()));
      const base = (baseName || "").trim();
      if (!existing.has(base.toLowerCase())) return base;
      let i = 2;
      while (existing.has(`${base.toLowerCase()} ${i}`)) i++;
      return `${base} ${i}`;
    } catch (_) {
      return baseName;
    }
  };

  const createFlow = async (name, templateKey) => {
    try {
      const { data: newFlow } = await api.post("/flowbuilder", { name });

      if (templateKey !== "blank" && FLOW_TEMPLATES[templateKey]) {
        const tpl = FLOW_TEMPLATES[templateKey];
        await api.post("/flowbuilder/flow", {
          idFlow: newFlow.id,
          nodes: tpl.nodes,
          connections: tpl.connections,
        });
      }

      handleClose();
      history.push(`/flowbuilder/${newFlow.id}`);
    } catch (err) {
      toastError(err);
      throw err;
    }
  };

  const handleCardClick = async (tpl) => {
    if (creating) return;

    setCreating(tpl.key);

    try {
      const uniqueName = await generateUniqueName(tpl.autoName);
      await createFlow(uniqueName, tpl.key);
    } finally {
      if (isMounted.current) setCreating(null);
    }
  };

  const handleFormSubmit = async (values) => {
    if (flowId) {
      try {
        await api.put("/flowbuilder", { name: values.name, flowId });
        onSave(values.name);
        handleClose();
        toast.success(i18n.t("webhookModal.toasts.update"));
      } catch (err) {
        toastError(err);
      }
    } else {
      setCreating("__button__");
      try {
        await createFlow(values.name, selectedTemplate);
      } finally {
        if (isMounted.current) setCreating(null);
      }
    }
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{ style: { borderRadius: 4 } }}
      >
        <DialogTitle id="form-dialog-title" style={{ position: "relative", paddingRight: 48 }}>
          {flowId ? "Editar fluxo" : "Criar novo fluxo"}
          <IconButton
            size="small"
            onClick={handleClose}
            disabled={!!creating}
            style={{ position: "absolute", right: 8, top: 8, color: "#6b7280" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Formik
          initialValues={contact}
          enableReinitialize={true}
          validationSchema={FlowSchema}
          onSubmit={(values, actions) => {
            setTimeout(async () => {
              await handleFormSubmit(values);
              actions.setSubmitting(false);
            }, 200);
          }}
        >
          {({ errors, isSubmitting, values, setFieldValue }) => (
            <Form>
              <DialogContent dividers>
                {/* Name field — only shown when editing an existing flow */}
                {flowId && (
                  <Field
                    as={TextField}
                    label={i18n.t("contactModal.form.name")}
                    name="name"
                    autoFocus
                    error={Boolean(errors.name)}
                    helperText={errors.name}
                    variant="outlined"
                    margin="dense"
                    className={classes.textField}
                    style={{ width: "100%" }}
                  />
                )}

                {/* Template picker — only on create */}
                {!flowId && (
                  <>
                    <Typography className={classes.sectionLabel}>
                      Clique no template para criar
                    </Typography>
                    <Grid container spacing={2}>
                      {TEMPLATE_OPTIONS.map((tpl) => {
                        const isCreating = creating === tpl.key;
                        const isDimmed = creating && creating !== tpl.key && creating !== "__button__";
                        const { IllustrationComp } = tpl;
                        return (
                          <Grid item xs={6} sm={4} key={tpl.key}>
                            <Paper
                              elevation={0}
                              className={[
                                classes.templateCard,
                                selectedTemplate === tpl.key && !isCreating
                                  ? classes.templateCardSelected
                                  : "",
                                isCreating ? classes.templateCardLoading : "",
                                isDimmed ? classes.templateCardDimmed : "",
                              ].join(" ")}
                              style={{ background: tpl.gradient }}
                              onClick={() => handleCardClick(tpl)}
                            >
                              {isCreating ? (
                                <div className={classes.spinnerWrap}>
                                  <CircularProgress size={36} style={{ color: "#6366f1" }} />
                                </div>
                              ) : (
                                <>
                                  {/* Illustration area */}
                                  <div className={classes.illustrationArea}>
                                    <IllustrationComp />
                                  </div>
                                  {/* Card body */}
                                  <div className={classes.cardBody}>
                                    <Typography className={classes.templateTitle}>
                                      {tpl.title}
                                    </Typography>
                                    <Typography className={classes.templateDesc}>
                                      {tpl.description}
                                    </Typography>
                                  </div>
                                </>
                              )}
                            </Paper>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </>
                )}
              </DialogContent>

              {/* Footer buttons only in edit mode */}
              {flowId && (
                <DialogActions>
                  <Button
                    onClick={handleClose}
                    color="secondary"
                    disabled={isSubmitting}
                    variant="outlined"
                  >
                    {i18n.t("contactModal.buttons.cancel")}
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting}
                    variant="contained"
                    className={classes.btnWrapper}
                  >
                    {i18n.t("contactModal.buttons.okEdit")}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                </DialogActions>
              )}
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default FlowBuilderModal;
